import produce from 'immer';
import uuid from 'uuid';
import { DELETE_NOTIFICATION, SHOW_NOTIFICATON } from '../actions/notificationActionsType';

const initialState = [];

export default function notifications(state = initialState, { type, payload }) {
  return produce(state, draftState => {
    switch (type) {
      case SHOW_NOTIFICATON: {
        const id = uuid.v4();
        draftState = draftState.push({ ...payload, id });
        break;
      }
      case DELETE_NOTIFICATION: {
        const index = state?.findIndex(e => e.id === payload);
        if (index > -1) {
          draftState = draftState.splice(index, 1);
        }
        break;
      }
      default: {
        break;
      }
    }
  });
}
